import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

interface RepairRecord {
    id: number;
    description?: string;
    cost: number;
    repairDate: string;
    licensePlate: string;
    repairShop?: string;
}

interface LinkRepairModalProps {
    isOpen: boolean;
    onClose: () => void;
    availableRecords: RepairRecord[];
    onLink: (id: number) => void;
}

const LinkRepairModal: React.FC<LinkRepairModalProps> = ({
    isOpen,
    onClose,
    availableRecords,
    onLink
}) => {
    const { t } = useLanguage();

    if (!isOpen) return null;

    return (
        <div className="modal show d-block" tabIndex={-1} style={{ background: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{t('link.repair.receipt')}</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        {availableRecords.length === 0 ? (
                            <p>{t('no.unlinked.repair.records')}</p>
                        ) : (
                            <div>
                                <p>{t('select.repair.record.to.link')}:</p>
                                {availableRecords.map(repair => (
                                    <div key={repair.id} className="border rounded p-2 mb-2 d-flex align-items-center justify-content-between">
                                        <div>
                                            <strong>{repair.description || t('no.description')}</strong><br />
                                            <small>{t('cost')}: ${repair.cost} | {t('repair.date')}: {new Date(repair.repairDate).toLocaleDateString()}</small><br />
                                            <small>{t('license.plate')}: {repair.licensePlate} | {t('repair.shop')}: {repair.repairShop || 'N/A'}</small>
                                        </div>
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm ms-2"
                                            onClick={() => onLink(repair.id)}
                                        >
                                            {t('link')}
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>{t('cancel')}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LinkRepairModal;
